import React from "react";

function Shipping({ width = 20, height = 20, fill = "#F8F6F6" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 3.75V5H11.875V14.375H8.0275C7.74875 13.3006 6.7825 12.5 5.625 12.5C4.4675 12.5 3.50125 13.3006 3.2225 14.375H2.5V11.25H1.25V15.625H3.2225C3.50125 16.6994 4.4675 17.5 5.625 17.5C6.7825 17.5 7.74875 16.6994 8.0275 15.625H13.2225C13.5013 16.6994 14.4675 17.5 15.625 17.5C16.7825 17.5 17.7488 16.6994 18.0275 15.625H20V10.5275L19.9606 10.4294L18.7106 6.67938L18.575 6.25H13.125V3.75H0ZM0.625 6.25V7.5H6.25V6.25H0.625ZM13.125 7.5H17.6756L18.75 10.7031V14.375H18.0275C17.7488 13.3006 16.7825 12.5 15.625 12.5C14.4675 12.5 13.5013 13.3006 13.2225 14.375H13.125V7.5ZM1.25 8.75V10H5V8.75H1.25ZM5.625 13.75C6.32312 13.75 6.875 14.3019 6.875 15C6.875 15.6981 6.32312 16.25 5.625 16.25C4.92688 16.25 4.375 15.6981 4.375 15C4.375 14.3019 4.92688 13.75 5.625 13.75ZM15.625 13.75C16.3231 13.75 16.875 14.3019 16.875 15C16.875 15.6981 16.3231 16.25 15.625 16.25C14.9269 16.25 14.375 15.6981 14.375 15C14.375 14.3019 14.9269 13.75 15.625 13.75Z"
        fill={fill}
      />
    </svg>
  );
}

export default Shipping;
